import { isRightToLeft } from 'js/lib/language';

import { PRODUCT_TYPE_NAMES } from 'bundles/browse-common/constants';
import { GUIDED_PROJECT, RHYME_PROJECT, SELF_PACED_PROJECT } from 'bundles/search-common/constants/entityTypes';

import _t from 'i18n!nls/browse-common';

const POSTGRADUATE_DIPLOMA_ENTITY_NAME = 'POSTGRADUATE DIPLOMA';
// Graduate and university certificates is a variant of master track not a 'product type' so exclude it from the PRODUCT_TYPE_NAMES constant.
const GRADUATE_CERTIFICATE_ENTITY_NAME = 'GRADUATE CERTIFICATE';
const UNIVERSITY_CERTIFICATE_ENTITY_NAME = 'UNIVERSITY CERTIFICATE';

const getProductDisplayTypeName = (productTypeName?: string | null) => {
  if (productTypeName === SELF_PACED_PROJECT) {
    return PRODUCT_TYPE_NAMES.SELF_PACED_PROJECT;
  } else if (productTypeName === GUIDED_PROJECT || productTypeName === RHYME_PROJECT) {
    return PRODUCT_TYPE_NAMES.GUIDED_PROJECT;
  }
  return productTypeName;
};

const capitalizeFirstLetterEachWord = (str: string | undefined): string | undefined => {
  if (!str) {
    return undefined;
  }
  return str.replace(/\w\S*/g, (word) => word.replace(/^\w/, (char) => char.toUpperCase()));
};

export const getTranslatedProductName = (productType?: string | null) => {
  const productName = getProductDisplayTypeName(productType);
  const productNameAllCapitalize = productName?.toUpperCase() || productName;
  const prettyProductName = capitalizeFirstLetterEachWord(productName?.toLowerCase());
  switch (productNameAllCapitalize) {
    case PRODUCT_TYPE_NAMES.COURSE:
      return _t('Course');
    case PRODUCT_TYPE_NAMES.GUIDED_PROJECT:
      return _t('Guided Project');
    case PRODUCT_TYPE_NAMES.SELF_PACED_PROJECT:
      return _t('Project');
    case PRODUCT_TYPE_NAMES.SPECIALIZATION:
      return _t('Specialization');
    case PRODUCT_TYPE_NAMES.CERTIFICATE:
      return _t('Professional Certificate');
    case PRODUCT_TYPE_NAMES.MASTERTRACK:
      return isRightToLeft(_t.getLocale())
        ? _t('#{R}MasterTrack Certificate', { R: String.fromCharCode(174) })
        : _t('MasterTrack#{R} Certificate', { R: String.fromCharCode(174) });
    case PRODUCT_TYPE_NAMES.DEGREE:
      return _t('Degree');
    case POSTGRADUATE_DIPLOMA_ENTITY_NAME:
      return _t('Post Graduate');
    case GRADUATE_CERTIFICATE_ENTITY_NAME:
      return _t('Graduate Certificate');
    case UNIVERSITY_CERTIFICATE_ENTITY_NAME:
      return _t('University Certificate');
    default:
      return prettyProductName || productName;
  }
};
